import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import { getAnnouncements,getAnnouncement } from "./utils";
import {
  getAgencies,
  getPriorities,
  getRoadways,
  getStates,
  getAnnouncementLogs,
  getEvents,
} from "./utils";

// Create the context
const AnnouncementsContext = createContext();

// Create a provider component
export const AnnouncementsProvider = ({ children }) => {
  const [reload, setReload] = useState(true);
  const [announcements, setAnnouncements] = useState([]);
  const [announcement, setAnnouncement] = useState();
  const [selectedAnnoucement, setSelectedAnnouncement] = useState(null);
  const [selectedAnnoucementLog, setSelectedAnnouncementLog] = useState(null);
  const [selectedAnnoucementLogs, setSlectedAnnouncementLogs] = useState(null);
  const [events, setEvents] =useState(null);
  const [selectedEventBtn, setSelectedEventBtn]= useState(false);
  
  const [filters, setFilters] = useState({
    state: "all",
    agency: "all",
    priority: "all",
    roadway: "all",
    type:"all",
    includeExpired:true,
  });

  const [filterValues, setFilterValues] = useState({
    states: [],
    agencies: [],
    priorities: [],
    roadways: [],
    type:["highPriorityPage", "construction", "newsItem", "siteNews", "transit","weather"],
    includeExpired:filters.includeExpired,
  });

  useEffect(() => {
    console.log("selectedAnnc", JSON.stringify(selectedAnnoucement));
    if(selectedAnnoucement!=null && selectedAnnoucement.id !==null){
    getAnnouncement(selectedAnnoucement.id,setAnnouncement);
    getEvents(selectedAnnoucement.id,setEvents);
  }
  }, [selectedAnnoucement]);

  useEffect(() => {
    getStates((data) => setFilterValues((prev) => ({ ...prev, states: data })));
    getAgencies((data) =>
      setFilterValues((prev) => ({ ...prev, agencies: data }))
    );
    getPriorities((data) =>
      setFilterValues((prev) => ({ ...prev, priorities: data }))
    );
    getRoadways((data) =>
      setFilterValues((prev) => ({ ...prev, roadways: data }))
    );
    // getType((data) =>
    //   setFilterValues((prev) => ({ ...prev, type: data }))
    // );
  }, []);

  const loadAnnouncements = useCallback(() => {
    getAnnouncements(
      filters.state,
      filters.agency,
      filters.priority,
      filters.roadway,
      filters.type,
      filters.includeExpired,
      setAnnouncements
    );
  }, [filters]);

  useEffect(() => {
    loadAnnouncements();
    setReload(false);
  }, [loadAnnouncements, reload]);

  useEffect(() => {
    if (null === selectedAnnoucementLog) {
      setSlectedAnnouncementLogs(null);
    } else {
      getAnnouncementLogs(
        selectedAnnoucementLog.id,
        setSlectedAnnouncementLogs
      );
    }
  }, [selectedAnnoucementLog]);

  return (
    <AnnouncementsContext.Provider
      value={{
        announcement,
        announcements,
        filters,
        selectedAnnoucement,
        selectedAnnoucementLog,
        filterValues,
        selectedAnnoucementLogs,
        events,
        setSelectedAnnouncementLog,
        setSelectedAnnouncement,
        setFilters,
        setAnnouncements,
        setAnnouncement,
        setEvents,
        setReload,
        selectedEventBtn,
        setSelectedEventBtn
      }}
    >
      {children}
    </AnnouncementsContext.Provider>
  );
};

// Custom hook to use the AnnouncementsContext
export const useAnnouncements = () => {
  const context = useContext(AnnouncementsContext);
  if (!context) {
    throw new Error(
      "useAnnouncements must be used within an AnnouncementsProvider"
    );
  }
  return context;
};
